import { useEffect, useState } from "react";
import { Panel } from "@/components/KpiCard";
import { Progress } from "@/components/ui/progress";
import { api, money } from "@/lib/api";

const statut = (s) => {
  if (s.inscrit) return ["text-slate-600", "Vous êtes inscrit aux fichiers TPS/TVQ (numéros dans Paramètres) : indicateur à titre informatif."];
  if (s.depasse) return ["text-red-600", `Seuil de 30 000 $ dépassé${s.depasse_depuis ? ` (au ${s.depasse_depuis})` : ""} : l'inscription aux fichiers TPS/TVQ est obligatoire.`];
  if (s.pct >= 80) return ["text-amber-700", "Vous approchez du seuil : prévoyez l'inscription aux fichiers TPS/TVQ."];
  return ["text-emerald-700", "Sous le seuil : vous restez « petit fournisseur »."];
};

export const SeuilPanel = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/seuil-tps-tvq").then((r) => setS(r.data)).catch(() => setS(null)); }, [refreshKey]);
  if (!s || !s.trimestres.length) return null;
  const [cls, msg] = statut(s);
  return (
    <Panel title="Seuil TPS/TVQ de 30 000 $ (4 derniers trimestres)" testId="seuil-panel">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-2xl font-bold tabular text-slate-900" data-testid="seuil-total">{money(s.total)} <span className="text-sm font-normal text-slate-500">/ {money(s.seuil)}</span></p>
        <span className="text-sm tabular text-slate-600" data-testid="seuil-pct">{String(s.pct).replace(".", ",")} %</span>
      </div>
      <Progress value={Math.min(s.pct, 100)} className="mt-3 h-2" data-testid="seuil-progress" />
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3">
        {s.trimestres.map((t) => (
          <div key={t.trimestre} className="rounded-md bg-slate-50 px-3 py-2" data-testid={`seuil-trimestre-${t.trimestre.replace(" ", "-")}`}>
            <p className="text-xs text-slate-500">{t.trimestre}</p>
            <p className="text-sm font-semibold tabular">{money(t.montant)}</p>
          </div>
        ))}
      </div>
      <p className={`mt-4 text-sm ${cls}`} data-testid="seuil-statut">{msg}</p>
      <p className="mt-1 text-xs text-slate-500">Revenus de location toutes plateformes (loyer + ménage, hors taxes), selon la date du séjour.</p>
    </Panel>
  );
};
